import IconAsMaskImage from 'app/components/IconAsMaskImage'

const SendIcon = ({ pureSvg, className, color, ...rest }) => {
  const svg = (
    <svg {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.92756 13.8159L17.4416 21.2239C18.1826 21.6289 19.0596 21.5659 19.7326 21.0529C20.4076 20.5389 20.7056 19.7059 20.5106 18.8789L19.1207 13.0013C19.0779 12.8202 18.9158 12.6925 18.7297 12.6933L9.99156 12.7309L9.98856 12.7309C9.57556 12.7309 9.24056 12.3969 9.23856 11.9839C9.23656 11.5689 9.57156 11.2329 9.98556 11.2309L18.7406 11.1923C18.9253 11.1915 19.0855 11.0642 19.1281 10.8844L20.5106 5.0389C20.7056 4.2119 20.4076 3.3779 19.7326 2.8629C19.3526 2.5739 18.9066 2.4269 18.4576 2.4269C18.1126 2.4269 17.7636 2.5139 17.4416 2.6909L3.92756 10.0989C3.23956 10.4769 2.82856 11.1709 2.82856 11.9579C2.82856 12.7439 3.23956 13.4389 3.92756 13.8159Z"
        fill="white"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default SendIcon
